export enum ContextStatus {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR,
  UNAUTHORIZED,
}
